import React, {FC} from 'react';
import styled from 'styled-components';
import uuid from 'uuid-random';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {useBrowserContext} from '../../../../libs/shared/ui/src/components/browser/browserContext';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {Layer} from '../../../../libs/shared/ui/src/components/layers/layer';
import {EducationTipChrome} from '../../../../libs/shared/ui/src/components/tip/educationTipChrome';
import {
  InfoBubbleCloseButton,
  InfoBubbleCloseButtonVariantsEnum,
} from '../../../../libs/shared/ui/src/components/tip/infoBubbleCloseButton';
import {InfoBubbleContent} from '../../../../libs/shared/ui/src/components/tip/infoBubbleContent';
import {InfoBubbleDescription} from '../../../../libs/shared/ui/src/components/tip/infoBubbleContentDescription';
import {InfoBubbleTitle} from '../../../../libs/shared/ui/src/components/tip/infoBubbleContentTitle';
import {InfoBubbleFooterActions} from '../../../../libs/shared/ui/src/components/tip/infoBubbleFooterActions';
import {InfoBubbleHeroHeader} from '../../../../libs/shared/ui/src/components/tip/infoBubbleHeroHeader';
import cxSurveyAnnouncementTipImgSrc from '../../../assets/images/cxSurveyAnnouncementTip.svg';
import {AppAnnouncementTipProps} from '../announcementTipHelpers';

/*
 * Props.
 */

interface CxSurveyAnnouncementTipProps extends AppAnnouncementTipProps {}

/*
 * Styles.
 */

// TODO: Standardize.
const StyledEducationTipChrome = styled(EducationTipChrome)`
  position: absolute;
  right: 16px;
  bottom: 16px;
`;

const StyledImg = styled.img`
  width: 100%;
`;

/*
 * Component.
 */

export const CxSurveyAnnouncementTip: FC<CxSurveyAnnouncementTipProps> = (props) => {
  const {openInBrowser} = useBrowserContext();

  const onCtaClick = () => {
    // So we can correlate survey responses with product analytics data without sending PII directly.
    const uid = uuid();
    openInBrowser(`https://velodu.questionpro.com/t/AaFd6Z4lcd?Custom5=${encodeURIComponent(uid)}`);
    props.onCtaClickAfter(undefined, {shouldClose: true, trackingData: {uid}});
  };

  return (
    <Layer>
      <StyledEducationTipChrome>
        <InfoBubbleHeroHeader>
          <StyledImg src={cxSurveyAnnouncementTipImgSrc} alt="" />
        </InfoBubbleHeroHeader>
        <InfoBubbleContent>
          <InfoBubbleTitle shouldWrapTitle>
            <Trans id="cx-survey-anouncement-title">Help shape the future of CX</Trans>
          </InfoBubbleTitle>
          <InfoBubbleDescription>
            <Trans id="cx-survey-anouncement-description">
              We&apos;re compiling a report on CX in 2025, and we want your perspective. Take our short survey
              to help us collectively define the future.
            </Trans>
          </InfoBubbleDescription>
          <InfoBubbleFooterActions $justifyContentRight>
            <Button variant={ButtonVariantsEnum.LINK} onClick={props.onCloseClick}>
              <Trans id="cx-survey-anouncement-dismiss">No thanks</Trans>
            </Button>
            <Button variant={ButtonVariantsEnum.PRIMARY} onClick={onCtaClick}>
              <Trans id="cx-survey-anouncement-cta">Take the survey</Trans>
            </Button>
          </InfoBubbleFooterActions>
        </InfoBubbleContent>
        <InfoBubbleCloseButton
          variant={InfoBubbleCloseButtonVariantsEnum.LIGHT_ON_DARK}
          onClose={props.onCloseClick}
        />
      </StyledEducationTipChrome>
    </Layer>
  );
};
